import { axios } from "lib/axios";

export const signInWithEmailAndPassword = data => {
  return axios.post("/auth/login", data);
};
